module.exports = __webpack_public_path__ + "img/cs.5d04e38d.svg";